const isShared = $(".section-wishlist").data("is-shared");

$(window).on("load", function (event) {
  if (Appmate.wk !== undefined) {
    let products = [];
    if (isShared && Appmate.wk.sharedWishlists.items.length > 0) {
      products = Appmate.wk.sharedWishlists.items[0].products;
    } else if (Appmate.wk.collection.items.length > 0) {
      products = Appmate.wk.collection.items[0].products;
    }

    const $wishlistCounter = $('[js-wishlist-page="counter"]');
    $wishlistCounter.text(Appmate.wk.collection.items[0].products.length);

    initProducts(products);
  } else {
    $(".section-wishlist").addClass("is-empty");
  }
});

const initProducts = (products) => {
  const productItems = $('[js-wishlist-page="container"]');
  const isTrade = $(".section-wishlist").data("is-trade");
  const tradeDiscount = isTrade
    ? (100 - $(".section-wishlist").data("trade-discount")) / 100
    : 1;

  products.forEach((product) => {
    let firstAvailable = product.selected_variant_id
      ? product.variants.find((x) => product.selected_variant_id == x.id)
      : product.variants.find((x) => x.available);

    if (firstAvailable === undefined) {
      firstAvailable = product.variants[0];
    }

    const mainImage =
      product.variants.length === 1
        ? product.images[0]
        : product.images.filter((image) => {
            return (
              image &&
              image.alt &&
              image.alt.includes(`${firstAvailable.title.split(" / ")[0]}`)
            );
          })[0];

    let buttonHtml = `<a js-quick-add data-id="${firstAvailable.id}" href="#" class="btn-simple">Add to bag</a>`;

    if (!product.available) {
      buttonHtml = `<a href="#" class="btn-simple btn-simple--warning">Out of Stock</a>`;
    }

    const priceHtml = isTrade
      ? `
    <span class="price__amount">
      <del>£${firstAvailable.price}</del>
      <p class="product__price product__price--trade">
        Trade Price
        <span class="money">£${firstAvailable.price * tradeDiscount}</span>
      </p>
    </span>
`
      : `<p class="product__price price">
  <span class="price__amount">
    <span class="money">£${firstAvailable.price}</span>
  </span>
</p>`;

    const productItemHtml = `
      <div class="wishlist-products__item" js-wishlist-page="item-${
        product.wishlist_item_id
      }">
        <div class="product-item-secondary product-item-secondary--black product-item-secondary--wishlist">
          <div class="product__content">
            <div class="product__top">
              <div class="product__wishlist">
                <button class="product__wishlist-remove wk-remove-item ${
                  isShared ? "hidden" : ""
                } " title="Remove from Wishlist" data-wk-remove-item="${
      product.wishlist_item_id
    }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18">
                    <g id="noun_Heart_1918280_Copy_7" data-name="noun_Heart_1918280 Copy 7" transform="translate(0 0)">
                      <path id="Shape" d="M10.212,17.745c-.489-.433-1.081-.972-1.738-1.57-.483-.441-1-.914-1.541-1.4A32.95,32.95,0,0,1,1.965,9.77C.868,8.288.076,7.217.009,5.626A5.265,5.265,0,0,1,1.363,1.809,5.658,5.658,0,0,1,4.495.085,6.041,6.041,0,0,1,7.989.535,6.836,6.836,0,0,1,10.5,2.385,6.833,6.833,0,0,1,13.01.535a6.036,6.036,0,0,1,3.5-.451,5.656,5.656,0,0,1,3.13,1.724,5.262,5.262,0,0,1,1.355,3.817c-.067,1.591-.859,2.662-1.956,4.144a33.041,33.041,0,0,1-4.969,5.007c-.538.485-1.057.958-1.542,1.4-.656.6-1.249,1.137-1.738,1.57L10.5,18Z" fill="#161b2f"/>
                    </g>
                  </svg>
                </button>
              </div>

              <a
                href="${product.url}?variant=${firstAvailable.id}"
                class="product__link">
              </a>

              <figure>
                <img
                  class="lazyload"
                  data-src="${
                    (mainImage
                      ? mainImage.src
                      : firstAvailable.image && firstAvailable.image.src) ||
                    product.images[0].src
                  }"
                  alt="${
                    (mainImage
                      ? mainImage.alt
                      : firstAvailable.image && firstAvailable.image.alt) ||
                    product.images[0].alt
                  }
                ">
              </figure>
            </div>

            <div class="product__entry">
              <h6>
                <a
                  href="${product.url}?variant=${firstAvailable.id}"
                >
                  ${product.title}
                </a>
              </h6>

              ${priceHtml}
            </div>
          </div>

          <div class="product__actions">
            ${buttonHtml}
          </div>
        </div>
      </div>
    `;

    products.length > 0
      ? productItems.append(productItemHtml)
      : productItems.append("<p>There are no products in your wishlist</p>");
  });

  if ($(".section-wishlist").length) {
    $(".section-wishlist").addClass("wishlist-initialized");
  }
};
